export type GroupFormSection = 'users' | 'mapPermissions' | 'filePermissions';

export interface GroupFormSectionConfig {
  key: GroupFormSection;
  label: string;
}

export const GROUP_FORM_SECTIONS: GroupFormSectionConfig[] = [
  { key: 'users', label: 'ADD USERS' },
  { key: 'mapPermissions', label: 'MAP PERMISSIONS' },
  { key: 'filePermissions', label: 'FILE PERMISSIONS' },
];
